module.exports = __webpack_public_path__ + "img/cooperate08.de9898f8.png";